import React from 'react';


import Select, { StylesConfig } from 'react-select';


function DropDownPicker ({options, onChange, value, isDisabled, minHeight, maxHeight = "150px"})  {


  const filterByNameOrUsername = (candidate, input) => {
    if (!input) return true;
    const search = input.toLowerCase();
    const label = (candidate.label || '').toLowerCase();
    const fullName = (candidate.data?.fullName || '').toLowerCase();
    return label.includes(search) || fullName.includes(search);
  };

  return (
      <Select
          placeholder={"Seleccione usuarios pertenecientes al grupo"}
          closeMenuOnSelect={true}
          closeMenuOnScroll={false}
          styles={{
              valueContainer: (base) => ({
                ...base,
                ...(minHeight ? { minHeight } : {}),
                maxHeight,
                overflowY: "auto",
                pointerEvents: "auto",
              }),
              multiValueLabel: (base) => ({
                ...base,
                backgroundColor: "#00D4E2",
                color: 'white',
                borderRadius: "none",
                fontSize: "1rem"
              }),
              multiValueRemove: (base) => ({
                  ...base,
                  backgroundColor: "#00D4E2",
                  color: 'white',
                  borderRadius: "none",
                  fontSize: "1rem"
                }),
            }}
          isMulti
          options={options}
          onChange={(value) => onChange(value)}
          defaultValue={value}
          isDisabled={isDisabled}
          filterOption={filterByNameOrUsername}
      />
    );
}
export default DropDownPicker;